import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    identifier: String,
    name: String,
    email: String,
  };

  connect() {
    this.handleReady = this.handleReady.bind(this);
    window.addEventListener("chatwoot:ready", this.handleReady);
  }

  disconnect() {
    window.removeEventListener("chatwoot:ready", this.handleReady);
  }

  open(event) {
    event.preventDefault();

    this.shouldOpenOnReady = true;
    this.tryOpenWidget();
  }

  handleReady() {
    this.tryOpenWidget();
  }

  tryOpenWidget() {
    if (!window.$chatwoot?.toggle) return;
    if (!this.shouldOpenOnReady) return;

    this.identifyCurrentUser();
    window.$chatwoot.toggle();
    this.shouldOpenOnReady = false;
  }

  identifyCurrentUser() {
    if (!this.hasIdentifierValue) return;
    if (window.__chatwootIdentifiedUserId === this.identifierValue) return;

    const user = {};

    if (this.hasEmailValue) user.email = this.emailValue;
    if (this.hasNameValue) user.name = this.nameValue;

    window.$chatwoot?.setUser(this.identifierValue, user);
    window.__chatwootIdentifiedUserId = this.identifierValue;
  }
}
